import React, { useState } from "react";
import "./App.css";

export default function App() {
  const [pdfFile, setPdfFile] = useState(null);
  const [code, setCode] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setPdfFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!pdfFile || !code) {
      alert("Bitte geben Sie einen Code ein und wählen Sie ein PDF aus.");
      return;
    }
  
    setIsUploading(true);
  
    const formData = new FormData();
    formData.append("file", pdfFile);
    formData.append("code", code);
    formData.append("email", "user@example.com"); // Replace or fetch from form/input
  
    try {
      const response = await fetch("/api/process-pdf/", {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
  
      if (result.success) {
        window.open(result.docUrl, "_blank");
      } else {
        alert(`Fehler: ${result.error}`);
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Fehler beim Hochladen.");
    } finally {
      setIsUploading(false);
    }
  };
  

  // Function to handle drag events
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setPdfFile(e.dataTransfer.files[0]);
      setFileName(e.dataTransfer.files[0].name);
    }
  };

  return (
    <div className="app-container">
      <div className="app-card">
        <div className="app-card-left">
          <div className="logo-container">
            <svg className="logo-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h1 className="app-title">Neben<span className="accent">kosten</span></h1>
          <p className="app-description">
            Leicht gemacht für Vermieter.

            Laden Sie hier Ihre Abrechnung vom Hausverwalter hoch und bekommen Sie in Kürze einen Briefentwurf als Google Doc.
          </p>
          <div className="feature-list">
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Schnell und einfach für Sie</div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Editierbarer Entwurf</div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Ohne Anmeldung</div>
            </div>
          </div>
        </div>

        <div className="app-card-right">
          <h2 className="form-title">Holen Sie sich Ihren Entwurf</h2>
          <form className="payment-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Nutzungscode</label>
              <div className="input-container">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M3 10H21" stroke="currentColor" strokeWidth="2"/>
                </svg>
                <input
                  type="text"
                  value={code}
                  onChange={handleCodeChange}
                  className="form-input"
                  placeholder="Code eingeben (Erhalt nach Bezahlung über Stripe, siehe unten)"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Dokument der Hausverwaltung (PDF)</label>
              <div 
                className={`file-drop-area ${fileName ? 'has-file' : ''}`}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="file-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 14L12 11L15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="file-message">
                  {fileName ? (
                    <span className="file-name">{fileName}</span>
                  ) : (
                    <>
                      <span className="drag-text">Drag & drop your PDF here</span>
                      <span className="or-text">- OR -</span>
                      <span className="browse-text">Browse files</span>
                    </>
                  )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className="file-input"
                />
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                className={`submit-button ${isUploading ? 'uploading' : ''}`}
                disabled={isUploading || !code || !pdfFile}
              >
                {isUploading ? (
                  <div className="loading-spinner"></div>
                ) : (
                  'Starten'
                )}
              </button>
              
              <div className="alternative-action">
                <span>Noch keine Credits gekauft?</span>
                <a
                  href="https://buy.stripe.com/aEU9C02mXcpQ94Q3co"
                  className="checkout-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bezahlung von Nutzungskontingenten mit Stripe
                </a>
              </div>
            </div>

            <div className="security-message">
              <svg className="lock-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Ihre Zahlung wird sicher von Stripe verwaltet.</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}